import { Component, OnDestroy, OnInit } from '@angular/core';
import { SessionInfoService } from 'src/app/services/session-info.service';
import {V3ExamSession, V3ExerciseSession} from "../../model/v3/cspa";
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-exercises-options',
    templateUrl: './exercises-options.component.html',
    styleUrls: ['./exercises-options.component.scss'],
    standalone: false
})
export class ExercisesOptionsComponent implements OnInit, OnDestroy {
  exerciseType: string
  exerciseName: string
  sessionInfoSubscription: Subscription
  constructor(
    private sessionInfoService: SessionInfoService,
  ) { }

  ngOnInit(): void {
    this.sessionInfoSubscription = this.sessionInfoService.getSessionInfo().subscribe(i => {
      this.exerciseType = i.session?.sectionName.split(',')[0]
      this.exerciseName = i.session?.chapterName.concat(', ', this.getExerciseName(i.session))
    })
  }

  ngOnDestroy(): void {
    if(this.sessionInfoSubscription) this.sessionInfoSubscription.unsubscribe()
  }

  isExam(session: V3ExamSession | V3ExerciseSession) {
    return session.path.includes("exam")
  }

  getExerciseName(session: V3ExamSession | V3ExerciseSession) {
    return this.isExam(session) ?
      (session as V3ExamSession)?.examName
      : (session as V3ExerciseSession)?.exerciseName
  }
}
